/* Maverick Metals — AJAX cart: add-to-cart interception, slide-over drawer,
   line qty/remove, and header count sync. Progressive enhancement — if fetch
   fails, add-to-cart forms fall back to a normal submit. */
(function () {
  var drawer = document.querySelector('[data-mm-drawer]');
  var itemsEl = drawer && drawer.querySelector('[data-mm-cart-items]');
  var emptyEl = drawer && drawer.querySelector('[data-mm-cart-empty]');
  var subtotalEl = drawer && drawer.querySelector('[data-mm-cart-subtotal]');
  var bulkEl = drawer && drawer.querySelector('[data-mm-cart-bulk]');
  var quoteNoteEl = drawer && drawer.querySelector('[data-mm-quote-note]');
  var QUOTE_HANDLE = 'custom-track'; /* the $0 quote-request product */
  var discountEl = drawer && drawer.querySelector('[data-mm-cart-discount]');
  var discountAmtEl = drawer && drawer.querySelector('[data-mm-cart-discount-amt]');
  var accountNoteEl = drawer && drawer.querySelector('[data-mm-account-note]');
  // Logged-in account customers (data-mm-account="1") get a note until Shopify has
  // applied their automatic discount to the cart; once it has, the Discounts row shows.
  var IS_ACCOUNT = !!(drawer && drawer.getAttribute('data-mm-account') === '1');

  // Bulk offer from the theme setting mm_bulk_offer_qty (0 = never). Non-blocking:
  // any quantity is buyable; at this cart total we surface the call-for-steeper-
  // pricing panel. Mirrors the PDP's bulk_offer_qty — keep the two in sync.
  var bulkAttr = drawer ? parseInt(drawer.getAttribute('data-mm-bulk-qty'), 10) : NaN;
  var BULK_QTY = isNaN(bulkAttr) ? 0 : bulkAttr;

  // Stick length by Hole Spacing ("8:6.75, 9:6.76, 10:6.77" + a default), so track
  // lines read "18 sticks · 121.5 ft". Same format as snippets/mm-stick-length.liquid.
  var lenDefault = drawer ? parseFloat(drawer.getAttribute('data-mm-len-default')) : NaN;
  if (isNaN(lenDefault) || lenDefault <= 0) lenDefault = 6.75;
  var lenMap = {};
  ((drawer && drawer.getAttribute('data-mm-lengths')) || '').split(',').forEach(function (p) {
    var kv = p.split(':');
    var k = parseFloat(kv[0]), v = parseFloat(kv[1]);
    if (!isNaN(k) && v > 0) lenMap[k] = v;
  });
  // "18 sticks · 121.5 ft" for lines with a Hole Spacing option; '' for anything else.
  function feetLine(it) {
    var opt = (it.options_with_values || []).filter(function (o) { return /spacing/i.test(o.name || ''); })[0];
    if (!opt) return '';
    var n = parseFloat(opt.value);
    var L = (!isNaN(n) && lenMap[n]) || lenDefault;
    var ft = (Math.round(it.quantity * L * 100) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 });
    return it.quantity + (it.quantity === 1 ? ' stick' : ' sticks') + ' · ' + ft + ' ft';
  }

  // "Change length" → the PDP with the current length pre-filled (mm_ft), after the
  // line is removed (click handler below) so the new length replaces it.
  function relengthUrl(url, lengthText) {
    var ft = parseFloat(lengthText);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + (isNaN(ft) ? '' : 'mm_ft=' + ft);
  }

  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mm-noscroll');
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mm-noscroll');
  }

  function render(cart) {
    document.querySelectorAll('[data-mm-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
    document.querySelectorAll('[data-mm-cart-count-text]').forEach(function (e) { e.textContent = cart.item_count; });
    // Subtotal is post-discount (total_price) so it matches what checkout will show.
    var sub = cart.total_price != null ? cart.total_price : cart.items_subtotal_price;
    if (subtotalEl) subtotalEl.textContent = money(sub);
    var disc = cart.total_discount || 0;
    if (discountEl) discountEl.hidden = !(disc > 0);
    if (discountAmtEl) discountAmtEl.textContent = '−' + money(disc);
    if (accountNoteEl) accountNoteEl.hidden = !(IS_ACCOUNT && disc === 0 && cart.item_count > 0);

    // Cart-total bulk offer: BULK_QTY+ combined sticks → show the steeper-pricing panel (0 = off).
    // Checkout stays available — the panel is an offer, not a gate.
    var bulk = BULK_QTY > 0 && cart.item_count >= BULK_QTY;
    if (bulkEl) bulkEl.hidden = !bulk;
    if (drawer) drawer.classList.toggle('is-bulk', bulk);

    // Quote-request reminder: the request only sends when checkout completes.
    if (quoteNoteEl) {
      var hasQuote = (cart.items || []).some(function (it) { return it.handle === QUOTE_HANDLE; });
      quoteNoteEl.hidden = !hasQuote;
    }

    if (!itemsEl) return;

    if (!cart.item_count) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    itemsEl.innerHTML = cart.items.map(function (it) {
      var thumb = it.image
        ? '<img src="' + esc(it.image) + '" alt="" width="56" height="56">'
        : '<span class="mm-hatch mm-litem__hatch"></span>';
      var variant = it.variant_title && it.variant_title !== 'Default Title'
        ? '<p class="mm-litem__variant mm-mono">' + esc(it.variant_title) + '</p>' : '';
      // Ordered by total feet with a cut stick (properties from the PDP): show the
      // length and LOCK the stick count — changing it would contradict the length.
      var cutLen = it.properties && it.properties['Total length'];
      var feet = cutLen ? '' : feetLine(it);
      if (cutLen) variant += '<p class="mm-litem__feet mm-mono">Total length: ' + esc(cutLen) + '</p>';
      if (feet) variant += '<p class="mm-litem__feet mm-mono">' + esc(feet) + '</p>';
      var qtyCtl = cutLen
        ? '<span class="mm-litem__locked mm-mono">' + it.quantity + (it.quantity === 1 ? ' stick' : ' sticks') +
            ' · <a href="' + esc(relengthUrl(it.url, cutLen)) + '" data-mm-relength="' + esc(it.key) + '">Change length</a></span>'
        : '<div class="mm-qty mm-qty--sm">' +
            '<button type="button" class="mm-qty__btn" data-mm-line-down aria-label="Decrease">&minus;</button>' +
            '<input type="number" class="mm-qty__val mm-mono" value="' + it.quantity + '" min="0" inputmode="numeric" data-mm-line-qty aria-label="Quantity">' +
            '<button type="button" class="mm-qty__btn" data-mm-line-up aria-label="Increase">+</button>' +
          '</div>';
      return '' +
        '<div class="mm-litem" data-key="' + esc(it.key) + '">' +
          '<div class="mm-litem__thumb">' + thumb + '</div>' +
          '<div class="mm-litem__info">' +
            '<p class="mm-litem__name mm-head">' + esc(it.product_title) + '</p>' +
            variant +
            '<div class="mm-litem__row">' +
              qtyCtl +
              (it.original_line_price > it.final_line_price
                ? '<span class="mm-litem__price mm-mono"><s class="mm-litem__was">' + money(it.original_line_price) + '</s> ' + money(it.final_line_price) + '</span>'
                : '<span class="mm-litem__price mm-mono">' + money(it.final_line_price) + '</span>') +
            '</div>' +
            '<button type="button" class="mm-litem__remove mm-mono" data-mm-line-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addForm(form) {
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refresh(); })
      .then(open)
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-mm-form]') || form.matches('.mm-card__addform')) {
      e.preventDefault();
      addForm(form);
    }
  });

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      // Direct wrapper hits count as outside-clicks too — closes the drawer even
      // if third-party CSS collapses the backdrop (seen live: app CSS hid it).
      if (e.target === drawer || e.target.closest('[data-mm-drawer-close]')) { close(); return; }
      var li = e.target.closest('[data-key]');
      if (!li) return;
      var key = li.getAttribute('data-key');
      var qtyEl = li.querySelector('[data-mm-line-qty]');
      var val = qtyEl ? parseInt(qtyEl.value, 10) : NaN;
      if (isNaN(val) || val < 1) val = 1;
      if (e.target.closest('[data-mm-line-up]')) change(key, val + 1);
      else if (e.target.closest('[data-mm-line-down]')) change(key, Math.max(0, val - 1));
      else if (e.target.closest('[data-mm-line-remove]')) change(key, 0);
    });

    // Typed quantities commit on change (blur / Enter). 0 removes the line.
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-mm-line-qty]');
      if (!input) return;
      var li = input.closest('[data-key]');
      if (!li) return;
      var q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) { input.value = input.defaultValue; return; }
      if (String(q) === input.defaultValue) { input.value = input.defaultValue; return; }
      change(li.getAttribute('data-key'), q);
    });
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-mm-line-qty]')) { e.preventDefault(); e.target.blur(); }
    });
  }

  // "Change length" (drawer + cart page): remove the cut line, then open the PDP with the
  // length pre-filled. Without JS the link still opens the PDP (old line stays).
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mm-relength]');
    if (!a) return;
    e.preventDefault();
    var href = a.getAttribute('href');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: a.getAttribute('data-mm-relength'), quantity: 0 })
    }).finally(function () { window.location.href = href; });
  });

  // Header cart link opens the drawer instead of navigating.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.mm-cart');
    if (link) { e.preventDefault(); refresh().then(open); }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  refresh();
})();
